import type { ProductCatalogOption } from "@/types/ProductCatalog";

function productDisplayName({ product }: { product: ProductCatalogOption }): string {
  return product.name?.trim() || "Untitled";
}

function compareProductNames(a: ProductCatalogOption, b: ProductCatalogOption): number {
  return productDisplayName({ product: a }).localeCompare(
    productDisplayName({ product: b }),
    undefined,
    { sensitivity: "base" },
  );
}

export function isProductArchived({ product }: { product: ProductCatalogOption }): boolean {
  return product.archivedAt != null && product.archivedAt !== "";
}

export function partitionProductCatalogOptions(products: ProductCatalogOption[]): {
  active: ProductCatalogOption[];
  archived: ProductCatalogOption[];
} {
  const active: ProductCatalogOption[] = [];
  const archived: ProductCatalogOption[] = [];

  for (const product of products) {
    if (isProductArchived({ product })) {
      archived.push(product);
    } else {
      active.push(product);
    }
  }

  active.sort(compareProductNames);
  archived.sort(compareProductNames);

  return { active, archived };
}

export function sortProductCatalogOptions(products: ProductCatalogOption[]): ProductCatalogOption[] {
  const { active, archived } = partitionProductCatalogOptions(products);
  return [...active, ...archived];
}
